<!-- /app/frontend/pages/Layout.svelte -->
<script>
  import Nav from '$lib/components/Nav.svelte';
  import { page } from '@inertiajs/svelte';
  import { onMount } from 'svelte';
  import { ModeWatcher,setMode } from "mode-watcher";
  import Toast, { toast } from "$lib/components/ui/toast";
  
  // 使用 Svelte 5 的 $effect 来监听 Inertia 数据的变化
  $effect(() => {
    // 这里的 $page.props.flash 是由 Rails 的 inertia_rails 插件自动注入的
    const flash = $page.props.flash;

    if (flash?.notice) {
      toast.success(flash.notice);
      // 清理 flash，防止重复弹出（Inertia 渲染机制通常会自动处理，但这样更稳）
      flash.notice = null;
    }

    if (flash?.alert) {
      toast.error(flash.alert);
      flash.alert = null;
    }
    
    if (flash?.info) {
      toast.info(flash.info);
      flash.info = null;
    }
  });

  onMount(() => {
    //setMode('dark');
    // 如果 localStorage 没值，才设为 dark
    if (!localStorage.getItem('mode-watcher-mode')) {
      //setMode('dark');
    }
    // 或者永远默认 dark（即使有 localStorage 也覆盖）
    
    console.log('当前页面 props:', $page.props);
  });

  let year = new Date().getFullYear();
</script>

<ModeWatcher />
<Toast />
<div class="min-h-screen flex flex-col  bg-neutral-100 dark:bg-neutral-900 ">
  <!-- <Nav /> -->
  <main class="flex-1">
    <slot />
  </main>
  <!-- <footer class="text-center text-sm text-gray-500 dark:text-gray-400 py-4">
    &copy; {year} fentime.cn
  </footer> -->
  
</div>